import * as React from 'react';

/* ============================================================================
   Titulo da tela, com a descricao em DICA no lugar de paragrafo impresso.

   POR QUE MUDOU (26/08/2026): cada tela abria com duas a tres linhas de texto
   explicativo embaixo do titulo. Somado ao cabecalho, aos cartoes de indicador e
   aos filtros, sobrava pouca altura para a lista - que e o motivo de a pessoa ter
   aberto a tela. E o texto e lido UMA vez: depois da segunda visita ele so ocupa
   espaco.

   A informacao nao foi jogada fora: ela vira dica ao passar o mouse (ou ao chegar
   pelo teclado) no icone ao lado do titulo.

   O ICONE E OBRIGATORIO, e nao um enfeite: dica sem nada que a anuncie e dica que
   ninguem encontra. Foi exatamente a reclamacao de quando as dicas dos campos
   viraram paragrafo - "antes tinha icone, passava o mouse e tinha texto".

   ABRE NO FOCO TAMBEM (`group-focus-within`), nao so no hover: em tela sensivel ao
   toque e para quem navega por teclado, hover nao existe.
   ============================================================================ */

export default function TituloTela({
  children,
  descricao,
}: {
  /** O titulo. Vem como children para aceitar JSX (nome do usuario, contagem). */
  children: React.ReactNode;
  /** Quando ausente, nao ha icone nenhum - titulo sozinho. */
  descricao?: React.ReactNode;
}) {
  if (!descricao) {
    return <h1 className="text-2xl font-extrabold tracking-[-0.03em]">{children}</h1>;
  }

  return (
    <div className="group relative flex items-center gap-1.5">
      <h1 className="text-2xl font-extrabold tracking-[-0.03em]">{children}</h1>

      <button
        type="button"
        aria-label="Sobre esta tela"
        /* `button` e nao `span`: precisa receber foco pelo teclado para a dica
           abrir sem mouse. `type=button` porque ha telas em que o cabecalho fica
           dentro de form - sem isso, clicar aqui enviaria o formulario. */
        className="grid h-4 w-4 flex-none place-items-center rounded-full border border-line text-[10px] font-bold text-muted-foreground transition-colors hover:border-primary hover:text-primary"
      >
        i
      </button>

      {/* `absolute` + `top-full`: a dica sai do fluxo, entao abrir e fechar nao
          empurra a tela - o motivo desta mudanca existir era ganhar altura. */}
      <div
        role="tooltip"
        /* `w-[460px] max-w-[86vw]` e NAO `w-[min(460px,86vw)]`: medido no CSS
           gerado, a versao com `min()` nao produz regra nenhuma - a virgula dentro
           do valor arbitrario faz o Tailwind descartar a classe em silencio, e a
           dica ficaria sem largura. Duas classes simples fazem o mesmo. */
        className="pointer-events-none absolute left-0 top-full z-30 mt-1 hidden w-[460px] max-w-[86vw] rounded-lg border border-line bg-surface p-3 text-[12px] font-normal leading-snug text-muted-foreground shadow-card group-hover:block group-focus-within:block"
      >
        {descricao}
      </div>
    </div>
  );
}
